import { Link } from "react-router-dom";
import { Loader2, Check } from "lucide-react";
import { fmtDate } from "@/lib/api";

export const Logo = ({ light = false }) => (
  <Link to="/" data-testid="brand-logo-link" className="flex items-center gap-2">
    <span className={`grid h-10 w-10 place-items-center rounded-xl font-black text-lg ${light ? "bg-[#C59B27] text-[#0F382C]" : "bg-[#0F382C] text-[#C59B27]"}`}>
      د
    </span>
    <span className={`whitespace-nowrap text-xl font-extrabold ${light ? "text-white" : "text-[#0F382C]"}`}>
      دارنا <span className={`font-medium text-sm ${light ? "text-white/60" : "text-[#5C7067]"}`}>| Darna</span>
    </span>
  </Link>
);

export const StatusBadge = ({ map, status, testId }) => {
  const s = map[status] || { label: status, cls: "bg-stone-50 text-stone-600 border-stone-200" };
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold ${s.cls}`}>
      {s.label}
    </span>
  );
};

export const Spinner = ({ label = "جاري التحميل..." }) => (
  <div className="flex items-center justify-center gap-2 py-16 text-[#5C7067]" data-testid="loading-spinner">
    <Loader2 className="h-5 w-5 animate-spin" /> {label}
  </div>
);

export const Empty = ({ icon: Icon, title, text, testId }) => (
  <div data-testid={testId} className="rounded-2xl border border-dashed border-[#E5DEC9] bg-white p-10 text-center">
    {Icon && <Icon className="mx-auto mb-3 h-10 w-10 text-[#C59B27]" />}
    <p className="font-bold text-[#0F382C]">{title}</p>
    {text && <p className="mt-1 text-sm text-[#5C7067]">{text}</p>}
  </div>
);

export const Steps = ({ flow, map, status, testId }) => {
  const idx = flow.indexOf(status);
  return (
    <div data-testid={testId} className="flex items-center gap-1 overflow-x-auto py-2">
      {flow.map((s, i) => (
        <div key={s} className="flex items-center gap-1 shrink-0">
          <div className={`flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold ${i <= idx ? "bg-[#0F382C] text-white" : "bg-[#F7F4EF] text-[#5C7067]"}`}>
            {i < idx && <Check className="h-3 w-3" />} {map[s].label}
          </div>
          {i < flow.length - 1 && <div className={`h-0.5 w-4 ${i < idx ? "bg-[#0F382C]" : "bg-[#E5DEC9]"}`} />}
        </div>
      ))}
    </div>
  );
};

export const History = ({ items = [], map }) => (
  <ol className="space-y-3 border-r-2 border-[#E5DEC9] pr-4">
    {items.map((h, i) => (
      <li key={i} className="relative text-sm">
        <span className="absolute -right-[22px] top-1.5 h-2.5 w-2.5 rounded-full bg-[#C59B27]" />
        <p className="font-semibold text-[#0F382C]">{map[h.status]?.label || h.status}</p>
        <p className="text-xs text-[#5C7067]">{fmtDate(h.at)} · {h.by}</p>
        {h.note && <p className="mt-1 text-[#1A2E26]">{h.note}</p>}
      </li>
    ))}
  </ol>
);

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between fade-up">
    <div>
      <h1 className="text-2xl sm:text-3xl font-extrabold text-[#0F382C]">{title}</h1>
      {subtitle && <p className="mt-1 text-sm sm:text-base text-[#5C7067]">{subtitle}</p>}
    </div>
    {children}
  </div>
);
